module.exports = "../../app/cells/components/subproduct_landings/benefit_cell.rb";